export enum ESTABLISHMENT_PERMISSIONS {
  ESTABLISHMENT_VIEW = 'ESTABLISHMENT_VIEW',
  ESTABLISHMENT_WRITE = 'ESTABLISHMENT_WRITE',
}
